@import '../../../globals/main.scss';

pn-multi-row-connected-dropdown-row {
  pn-date-picker .pn-date-picker {
    container-type: normal;
  }

  gap: 1rem;

  .connected-dropdown__row.input-row pn-select,
  .connected-dropdown__row.input-row pn-input {
    width: 25%;
  }

  .connected-dropdown-parent-element {
    margin-bottom: 0.5rem;
  }

  pn-select {
    width: 35%;
  }

  pn-marketweb-input {
    width: 10%;

    input {
      height: 4.3rem;
    }
  }

  .connected-dropdown {
    padding: 1rem;
    border-left: 0.2rem solid $blue700;

    &:hover {
      background-color: $gray25;
    }

    &__toggle-date-button {
      width: 20%;
      margin-bottom: 0.5rem;
      align-self: center;
    }

    &__row {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      margin-bottom: 1rem;
      justify-content: space-between;

      &__no-margin {
        margin: 0;
      }
    }

    &__multi-date-row {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-bottom: 1rem;
    }

    &__button-container {
      display: flex;
      align-items: flex-end;
      gap: 1rem;
    }

    &__button {
      background-color: #ffffff;
      border: solid;
      border-width: 0.1rem;
      border-radius: 0.8rem;
      border-color: $blue700;
      padding: 0.4rem 0.8rem;
      color: $blue700;
      font-size: 1.4rem;
      text-align: center;
      text-decoration: none;
      cursor: pointer;

      &:hover,
      &.active {
        background-color: $blue900;
        border-color: $blue900;
        color: #ffffff;
      }
    }

    &__buttom-container-right {
      display: flex;
    }

    &__button-right {
      margin-left: auto;
    }

    &__label-container {
      margin-bottom: 0.4rem;
      color: $gray700;
      font-size: 0.875em;
      justify-content: space-between;
      align-items: flex-end;
    }

    &__checkbox {
      display: flex;
      gap: 0.5rem;
    }

    &__date-slot {
      border: 0.1rem solid $blue700;
      margin-bottom: 1rem;
      padding: 1rem;
    }
  }

  .generated-date-row {
    border-bottom: 0.1rem solid $blue700;
  }
}